export default "__VITE_ASSET__LSp1x7Br__"